export { PageHeading } from './PageHeading';
export type { PageHeadingProps } from './PageHeading.types';
